import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';
// @mui
import { Card, CardHeader, Box } from '@mui/material';
// components
import { BaseOptionChart } from '../../../components/chart';
import PlainSelect from '../../../components/plain-inputs/PlainSelect';


// ----------------------------------------------------------------------

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function AppWebsiteVisits({ title, subheader, chartLabels, chartData, setYear, yearList, selectedYear, ...other }) {
  const {t} = useTranslation();
  const chartOptions = merge(BaseOptionChart(), {
    plotOptions: { bar: { columnWidth: '16%' } },
    fill: { type: chartData.map((i) => i.fill) },
    labels: chartLabels,
    xaxis: { type: 'category' },
    yaxis: {
      labels: {
        formatter: (value) => {
          
          return value.toFixed(2)
        }
      }
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(2)}`;
          }
          return y;
        },
      },
    },
  });
  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />
      
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        {setYear && (
          <PlainSelect style={{width: "150px"}} name="year" label={t('year')} value={selectedYear} onChange={setYear} options={yearList} />
        )}

        <ReactApexChart type="line" series={chartData} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
}
